import "../synchronisemenu.scss";
import React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { type ThunkDispatch } from "redux-thunk";
import { hideDialog, showDialog } from "../../../../Actions/Dialogs/DialogActions";
import Button, { CancelOptionButton } from "../../../../Common/Buttons/Button";
import { runUploadQueue } from "../../../../Workers/Upload/UploadAgent";

const connector = connect();

type PropsFromRedux = ConnectedProps<typeof connector> & {
    dispatch: ThunkDispatch<any, any, any>;
};

export class ForceUploadDialog extends React.Component<PropsFromRedux> {
    public onCancel = (): void => {
        this.props.dispatch(hideDialog());
    };

    public onReset = (e: React.MouseEvent<HTMLButtonElement>): void => {
        e.stopPropagation();

        this.props.dispatch(hideDialog());
        this.props.dispatch(showDialog(
            "Reset Upload Queue",
            <p><b>Warning!</b> Resetting the upload queue may result in <b>duplicate</b> uploads</p>,
            "danger",
            [ CancelOptionButton, {
                label   : "Continue",
                classes : [ "button-danger" ],
                callback: (): void => {
                    runUploadQueue(true, true);
                },
            }]
        ));
    };

    public onRun = (): void => {
        runUploadQueue(true);
        this.props.dispatch(hideDialog());
    };

    public render(): React.ReactNode {
        return (
            <div className="force-upload-dialog">
                <p>This will attempt to upload any failed requests to the Shopfront server.</p>
                <ul>
                    <li>Upload retries the same request.</li>
                    <li>Reset & Upload clears the duplicate request ID and uploads it as a new request.</li>
                </ul>
                <p>
                    You’ll typically want to just use Upload unless you’ve modified the general settings
                    or under Shopfront advisement.
                </p>
                <div className="buttons">
                    <Button
                        classes={[ "button-cancel" ]}
                        onClick={this.onCancel}
                    >
                        Cancel
                    </Button>
                    <Button
                        classes={[ "button-danger" ]}
                        onClick={this.onReset}
                    >
                        Reset & Upload
                    </Button>
                    <Button
                        classes={[ "button-save" ]}
                        onClick={this.onRun}
                    >
                        Upload
                    </Button>
                </div>
            </div>
        );
    }
}

export default connector(ForceUploadDialog);
